import { render, staticRenderFns } from "./PartnerConfirmRegister.vue?vue&type=template&id=10454054"
import script from "./PartnerConfirmRegister.vue?vue&type=script&lang=ts"
export * from "./PartnerConfirmRegister.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports